import {
  loadInvites as load,
  generateInvite as generate,
  revokeInvite as revoke,
} from '../services/api/invites';
import actionTypes from './action_types';

export function loadInvites() {
  return (dispatch, getState) => {
    const userId = getState().auth.user.id;

    return load(userId)
      .then(({ invites }) => {
        return dispatch({
          type: actionTypes.INVITES_LOADED,
          payload: { invites },
        });
      });
  };
}

export function generateInvite() {
  return (dispatch, getState) => {
    const userId = getState().auth.user.id;

    return generate(userId)
      .then(({ invite }) => {
        return dispatch({
          type: actionTypes.INVITE_GENERATED,
          payload: { invite },
        });
      });
  };
}

export function revokeInvite(inviteId) {
  return (dispatch, getState) => {
    const userId = getState().auth.user.id;

    return revoke(userId, inviteId)
      .then(() => {
        return dispatch({
          type: actionTypes.INVITE_REVOKED,
          payload: { inviteId },
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/invites.js